import { useState } from 'react';

export const PhotoCompare = ({ beforeImage, afterImage }) => {
  const [position, setPosition] = useState(50);

  const handleMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX || e.touches?.[0]?.clientX) - rect.left) / rect.width * 100;
    setPosition(Math.min(Math.max(x, 0), 100));
  };

  if (!beforeImage || !afterImage) {
    return (
      <div className="aspect-[3/4] bg-[#161625] rounded-xl flex items-center justify-center text-gray-500">
        Need both photos to compare
      </div>
    );
  }

  return (
    <div 
      className="relative aspect-[3/4] rounded-xl overflow-hidden cursor-ew-resize select-none touch-none"
      onMouseMove={handleMove}
      onTouchMove={handleMove}
      data-testid="photo-compare"
    >
      {/* After image (full) */}
      <img 
        src={afterImage} 
        alt="After" 
        className="absolute inset-0 w-full h-full object-cover"
      />
      
      {/* Before image (clipped) */}
      <div 
        className="absolute inset-0 overflow-hidden"
        style={{ clipPath: `inset(0 ${100 - position}% 0 0)` }}
      >
        <img 
          src={beforeImage} 
          alt="Before" 
          className="w-full h-full object-cover"
        />
      </div>
      
      {/* Slider handle */}
      <div 
        className="absolute top-0 bottom-0 w-1 bg-white shadow-lg"
        style={{ left: `${position}%`, transform: 'translateX(-50%)' }}
      >
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-xl">
          <div className="flex gap-0.5">
            <div className="w-0 h-0 border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent border-r-[6px] border-r-gray-800" />
            <div className="w-0 h-0 border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent border-l-[6px] border-l-gray-800" />
          </div>
        </div>
      </div>
      
      {/* Labels */}
      <div className="absolute top-3 left-3 px-2 py-1 bg-black/60 rounded text-xs font-bold uppercase">
        Before
      </div>
      <div className="absolute top-3 right-3 px-2 py-1 bg-black/60 rounded text-xs font-bold uppercase">
        After
      </div>
    </div>
  );
};
